<template>

     <template v-if="currentSchoolyear && adminSchoolyear">

        <el-card shadow="hover">
            <el-row align="middle">
                <el-col :span="12">
                    <div class="text-left">
                        <h3>{{ $t('coursesList') }}</h3>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="text-right">
                        <el-button size="default" @click="addItem()">
                            {{ $t('add') }}
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-table :data="pagedTableData" :empty-text="$t('noData')" style="width: 100%" border stripe v-loading="isLoading">

                <el-table-column type="index" :index="indexMethod"> </el-table-column>
                <el-table-column sortable :label="$t('name')" prop="name"> </el-table-column>
                <el-table-column sortable :label="$t('code')" prop="code"> </el-table-column>

                <el-table-column align="right">

                    <template #header>
                        <el-input v-model="search" size="small" :placeholder="$t('search')" />
                    </template>

                    <template #default="scope">
                        <el-button size="small" @click="editItem(scope.$index, scope.row)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteItem(scope.$index, scope.row)">
                            {{ $t('delete') }}
                        </el-button>
                    </template>

                </el-table-column>

            </el-table>

            <div style="text-align: center; margin-top: 20px">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="setPage"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </el-card>

        <el-dialog :title="$t('addCourse')" v-model="addDialog" width="65%">

            <el-form :inline="true" :model="addCourse" :rules="rules" :ref="addCourseForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="addCourse.name"/>
                </el-form-item>

                <el-form-item prop="code" :label="$t('code')">
                    <el-input
                        :placeholder="$t('code')"
                        v-model="addCourse.code"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(addCourseForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(addCourseForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

        <el-dialog :title="$t('editCourse')" v-model="editDialog" width="65%">

            <el-form :inline="true" :model="editCourse" :rules="rules" :ref="editCourseForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="editCourse.name"/>
                </el-form-item>

                <el-form-item prop="code" :label="$t('code')">
                    <el-input
                        :placeholder="$t('code')"
                        v-model="editCourse.code"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(editCourseForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(editCourseForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

     </template>

     <el-alert :title="$t('noCurrentSchoolyearWarning')" type="warning" v-else/>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import fr from 'element-plus/lib/locale/lang/fr'

import accessManager from '@/mixins/access-manager'

export default {
    name: 'Courses',
    mixins: [accessManager],
    data() {
      return {
        primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
        editCourse: {
            name: '',
            code: ''
        },
        addCourse: {
            name: '',
            code: ''
        },
        rules: {
            name: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            code: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ]
        },
        editCourseForm: 'editCourseForm',
        addCourseForm: 'addCourseForm',
        currentEditItem: null,
        editDialog: false,
        isLoading: false,
        addDialog: false,
        tableData: [],
        pageSize: 6,
        locale: fr,
        search: '',
        total: 0,
        page: 1
      }
    },
    created() {

      this.fetchCourses()

    },
    computed:{
      ...mapState({
        userData: state => state.session.userData
      }),
      ...mapGetters({
        getSettingValue: 'settings/getSettingValue'
      }),
      pagedTableData() {

        this.total = this.searching.length

        return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)

      },
      searching() {

        if (!this.search) {
            this.total = this.tableData.length
            return this.tableData
        }

        this.page = 1

        return this.tableData.filter(data => (
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            (data.code && data.code.toLowerCase().includes(this.search.toLowerCase()))
        ))

      }
    },
    methods: {
      ...mapActions({
         fetchCoursesDB: 'courses/fetchCoursesDB',
      }),
      setPage (val) {

         this.page = val

      },
      indexMethod(index) {

         return index + ((this.page - 1) * this.pageSize) + 1

      },
      async fetchCourses(){

        if (!this.adminSchoolyear) return

        this.isLoading = true

        let resp = await this.fetchCoursesDB({
            action: 'getCourses',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp.success){

            if (resp.data) this.tableData = resp.data

        }else{

            this.$message.error(this.$t('anErrorOccured'))

        }

        this.isLoading = false

      },
      addItem(){

           if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
           }

           this.addDialog = true

      },
      async editItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.currentEditItem = item

            this.editCourse.name = item.name
            this.editCourse.code = item.code

            this.editDialog = true

      },
      deleteItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.$confirm(this.$t('deleteCourseQuestion'), this.$t('delete'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
            })
            .then(async () => {

                let task = await this.fetchCoursesDB({
                    action: 'deleteCourse',
                    params: {
                        id: item.id
                    }
                })

                if (task.success){

                    this.$message.success(this.$t('success'))
                    this.fetchCourses()

                }else{

                    this.$message.error(this.$t('anErrorOccured'))

                }

            })
            .catch(() => {

            })

      },
      submitForm(ref){

            this.$refs[ref].validate(async (valid) => {
                if (valid) {

                    if (ref === this.addCourseForm){

                        let task = await this.fetchCoursesDB({
                            action: 'addCourse',
                            params: {
                                code: this.addCourse.code,
                                name: this.addCourse.name,
                                schoolyear: this.adminSchoolyear
                            }
                        })

                        if (task.success) this.$message.success(this.$t('success'))
                        else this.$message.error(this.$t('anErrorOccured'))

                    }else{

                        let newData = {}

                        if (this.currentEditItem.name !== this.editCourse.name) {
                            newData['name'] = this.editCourse.name
                        }

                        if (this.currentEditItem.code !== this.editCourse.code) {
                            newData['code'] = this.editCourse.code
                        }

                        if (!this.$_.isEmpty(newData)){
                            let task = await this.fetchCoursesDB({
                                action: 'editCourse',
                                params: {
                                    id: this.currentEditItem.id,
                                    data: newData
                                }
                            })

                            if (task.success) this.$message.success(this.$t('success'))
                            else this.$message.error(this.$t('anErrorOccured'))
                        }

                    }

                    this.cancelForm(ref)
                    this.fetchCourses()

                } else {
                    return false
                }
            })

      },
      cancelForm(ref){

            this.$refs[ref].resetFields()

            if (ref === this.addCourseForm) this.addDialog = false
            else this.editDialog = false

      }
    },
}
</script>